export const optionChild = {
  enter:false,
  sortable: true,
  height: "auto",
  calcHeight: 95,
  tip: false,
  stripe: true,
  searchShow: true,
  searchMenuSpan: 6,
  tree: true,
  border: true,
  index: true,
  selection: true,
  viewBtn: true,
  menuWidth: 150,
  dialogWidth: 880,
  dialogClickModal: false,
  column: [
    {
      label: "资源组ID",
      prop: "groupId",
      span: 24,
      addDisplay: false,
      editDisplay: false,
      hide: true
    },
    {
      label: "资源CODE",
      prop: "code",
      search: true,
      span: 14,
      align: "center",
      rules: [
        {
          required: true,
          message: "请输入资源CODE",
          trigger: "blur"
        }
      ]
    },
    {
      label: "模板名称",
      prop: "title",
      span: 14,
      search: true,
      rules: [
        {
          required: true,
          message: "请输入模板名称",
          trigger: "blur"
        }
      ]
    },
    {
      label: "图片",
      prop: "image",
      type: "upload",
      slot: true,
      width: 300,
      imgHeight: 50,
      // align: "center",
      accept: ["image/png","image/jpeg"],
      action: "/lebo-resource/oss/endpoint/put-file?code=lebotob",
      listType: "picture-img",
      span: 24,
      tip: "只能上传jpg/png，且不超过1M",
      propsHttp: {
        res: "data",
        url: "link"
      },
      rules: [
        {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }
      ]
    },
    {
      label: "渠道配置",
      prop: "appidFilterType",
      type: "select",
      row: true,
      hide: true,
      addDisplay: false,
      editDisplay: false,
      dicData: [
        { label: "全部渠道", value: 0 },
        { label: "渠道黑名单", value: 1 },
        { label: "渠道白名单", value: 2 }
      ]
      // ,
      // change: ({ value, column }) => {
      //   console.log('值改变', value, column)
      //   console.log(this)
      // },
    },
    {
      label: "渠道过滤",
      prop: "appidFilterList",
      width:200,
      slot: true,
      formslot: true,
      display: false,
      addDisplay: false,
      editDisplay: false,
      hide:true
    },
    {
      label: "最大版本",
      prop: "maxCv",
      type: 'number',
      span: 12,
      value: 0,
      tip: '0代表此项不生效,例如：5.5.5 版本填写50505',
      minRows: 0,
      hide: true,
      addDisplay: false,
      editDisplay: false,
      controlsPosition: 'top',
    },
    {
      label: "最小版本",
      prop: "minCv",
      type: 'number',
      span: 12,
      addDisplay: false,
      editDisplay: false,
      tip: '0代表此项不生效,例如：5.5.5 版本填写50505',
      value: 0,
      minRows: 0,
      hide: true,
      controlsPosition: 'top',
    },
    {
      label: "用户标签",
      prop: "userTags",
      type: 'select',
      addDisplay: false,
      editDisplay: false,
      dataType: "string",
      multiple: true,
      hide: true,
      dicUrl: "/lebo-system/dict-biz/dictionary?code=USER_TAGS",
      tip: '不选择过滤条件，此项筛选不生效，相应选项对应相应匹配筛选结果',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      span: 12
    },
    {
      label: "用户类型",
      prop: "userTypes",
      type: 'select',
      dataType: "string",
      multiple: true,
      hide: true,
      addDisplay: false,
      editDisplay: false,
      dicUrl: "/lebo-system/dict-biz/dictionary?code=USER_TYPES",
      tip: '不选择过滤条件，此项筛选不生效，相应选项对应相应匹配筛选结果',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      span: 12
    },
    {
      label: "分成几等份",
      prop: "modKey",
      type: 'number',
      value: 0,
      tip: '0代表此项不生效',
      span: 12,
      minRows: 0,
      addDisplay: false,
      editDisplay: false,
      maxRows: 100,
      hide: true,
      controlsPosition: 'top',
    },
    {
      label: 'A/B集合',
      prop: 'modAns',
      type: 'select',
      dataType: "string",
      tip: '不选代表此项不生效',
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      hide: true,
      span: 12,
      dicData: [{
        label: '0',
        value: 0
      }, {
        label: '1',
        value: 1
      }, {
        label: '2',
        value: 2
      }, {
        label: '3',
        value: 3
      }, {
        label: '4',
        value: 4
      }, {
        label: '5',
        value: 5
      }, {
        label: '6',
        value: 6
      },
      {
        label: '7',
        value: 7
      },
      {
        label: '8',
        value: 8
      },
      {
        label: '9',
        value: 9
      }]
    },
    {
      label: "次数限制",
      prop: 'limitDays',
      type: 'number',
      tip: '0表示不限制,数字代表每N天内最多下发一次',
      span: 12,
      value: 0,
      addDisplay: false,
      editDisplay: false,
      minRows: 0,
      maxRows: 999,
      hide: true,
      controlsPosition: 'top',
    },
    {
      label: "随机排序",
      prop: "priority",
      hide: true,
      addDisplay: false,
      editDisplay: false,
      type: "select",
      dicData: [
        {
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ]
    },
    {
      // 0:无 1:打开H5 2:打开其他应用 3:文件下载  4:应用内跳转
      label: "事件类型",
      prop: "eventType",
      type: "select",
      slot: true,
      hide: true,
      addDisplay: false,
      editDisplay: false,
      value: 0,
      dicUrl: '/lebo-system/dict-biz/dictionary?code=APP_RESOURCE_CONFIG',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      rules: [{
        required: true,
        message: "请选择事件类型",
        trigger: "click"
      }]
    },
    {
      label: "事件响应",
      prop: "eventBody",
      addDisplay: false,
      editDisplay: false,
      hide: true
    },
    {
      label:"状态",
      prop:"status",
      // hide:true,
      span: 14,
      row: true,
      type:"select",
      dicData:[
        {
          label:"启用",
          value:1
        },
        {
          label: "禁用",
          value: 2
        }
      ]
    },
    {
      label: "优先级",
      prop: "priority",
      hide: true,
      type: "number",
      addDisplay: false,
      editDisplay: false,
      value: 0,
      display: false
    },
    {
      label: "排序",
      prop: "sort",
      hide: true,
      type: "number",
      addDisplay: false,
      editDisplay: false,
      value: 0,
      display: false
    },
    {
      label: "开始时间",
      prop: "effectiveStartTime",
      hide: true,
      type: "datetime",
      addDisplay: false,
      editDisplay: false,
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "yyyy-MM-dd HH:mm:ss"
    },
    {
      label: "结束时间",
      prop: "effectiveEndTime",
      hide: true,
      type: "datetime",
      addDisplay: false,
      editDisplay: false,
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "yyyy-MM-dd HH:mm:ss"
    }
  ]
};
